const {
  getVendor,
  getConfigPage,
  getEvalList,
  getintprocess,
  getDraftJob,
  getsearchresloc,
  getsearchresskl,
  addConfig,
  editConfig,
  dosanddontslist,
  checkTestAutocorrected,
} = require("../../utils/apiFunctions");

// GET ALL VENDORS FOR TAGGING TO A JD
const getVendors = async (vueObj) => {
  if (vueObj.checkIPSelected) {
    try {
      let payload = {
        type: 1,
        searchQuery: vueObj.searchVen,
        sortColumn: "updatedAt",
        sortOrder: "-1",
        page: vueObj.venPage,
        count: vueObj.count,
      };
      const response = await getVendor(payload);
      if (response.status == 200) {
        if (vueObj.venPage == 0) {
          vueObj.vendors = response.data.data.data;
        } else {
          vueObj.vendors = [...vueObj.vendors, ...response.data.data.data];
        }
        vueObj.showLoader =
          response.data.data.total !== response.data.data.pageEnd;
      }
      vueObj.totalVen = response.data.data.total;
      vueObj.venPageEnd = response.data.data.pageEnd;
      vueObj.showSpinner = false;
    } catch (error) {
      vueObj.showSpinner = false;
      console.error(error);
    }
  }
};
// GET ALL CONFIGURATIONS TO POPULATE CONFIGURATION MODAL
// INCLUDES SEARCH,SORT,PAGINATION OF CONFIG
const openConfigModal = async (vueObj) => {
  try {
    let payload = {
      page: vueObj.currentPage - 1,
      count: vueObj.configCount,
      sortBy: {
        column: vueObj.filterColumnConfig,
        order: vueObj.sortByOrder,
      },
      searchQuery: vueObj.searchConfig,
      filters: { testType: vueObj.testoption },
      configID:
        vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
          .configID,
    };
    if (vueObj.testoption == null) {
      delete payload.filters;
    }
    if (!vueObj.enableConfigFilter) {
      delete payload.sortBy;
    }
    const response = await getConfigPage(payload);
    if (response.status == 200) {
      vueObj.configurations = response.data.data.data;
      vueObj.selectedConfiguration = response.data.data.selectedConfig;
      vueObj.total = response.data.data.total;
      vueObj.pageStart = response.data.data.pageStart;
      vueObj.pageEnd = response.data.data.pageEnd;
      vueObj.totalPages = Math.ceil(
        parseInt(vueObj.total) / parseInt(vueObj.configCount)
      );
    }

    const element = document.getElementById("config");
    element.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    vueObj.goToPage = "";
  } catch (error) {
    console.error(error);
  }
};

const getEvaluators = async (vueObj) => {
  try {
    let payload = {
      searchQuery: vueObj.searchEval,
      sortBy: {
        column: "updatedAt",
        order: false,
      },
      tag: "0",
      page: vueObj.evalPage,
      count: vueObj.count,
    };
    const response = await getEvalList(payload);
    if (response.status == 200) {
      if (vueObj.evalPage == 0) {
        vueObj.evaluators = response.data.data.data;
      } else {
        vueObj.evaluators = [...vueObj.evaluators, ...response.data.data.data];
      }
      vueObj.showEvalLoader =
        response.data.data.total !== response.data.data.pageEnd;
    }
    vueObj.totalEval = response.data.data.total;
    vueObj.evalPageEnd = response.data.data.pageEnd;
  } catch (error) {
    console.error(error);
  }
};
// GET ALL INTERVIEW PROCESS
const getIntProcess = async (vueObj, flag) => {
  try {
    vueObj.showSpinner = true;
    let payload = {
      searchQuery: vueObj.searchIP,
      type: "1",
      sortBy: "createdAt",
      order: "-1",
      page: vueObj.ipPage,
      count: 15,
    };
    const response = await getintprocess(payload);
    if (response.status == 200) {
      vueObj.interviewProcess = [];
      if (vueObj.ipPage == 0) {
        vueObj.interviewDetails = response.data.data.data;
      } else {
        vueObj.interviewDetails = [
          ...vueObj.interviewDetails,
          ...response.data.data.data,
        ];
      }
      vueObj.showCircleLoader =
        response.data.data.total !== response.data.data.pageEnd;
      vueObj.totalIPPage = response.data.data.total;
      vueObj.ipPageEnd = response.data.data.pageEnd;
      vueObj.interviewDetails.forEach((ip) => {
        vueObj.interviewProcess.push({
          name: ip.name,
          value: {
            interviewProcessID: ip.interviewProcessID,
            name: ip.name,
            process: ip.process,
          },
        });
      });
    } else {
      vueObj.errorModal("Something went wrong");
    }
    if (flag) {
      vueObj.getEvaluators();
    }
  } catch (error) {
    console.error(error);
    vueObj.errorModal("Something went wrong");
  }
};

const getJobDetails = async (vueObj) => {
  vueObj.LoaderStatus = true;
  try {
    let payload = {
      type: 1,
      jobID: vueObj.$route.query.jobID || vueObj.$route.params.jobID,
    };
    const response = await getDraftJob(payload);
    if (response.status == 200) {
      vueObj.jobDetail = response.data.data;
      vueObj.getRequiredDocuments();
      handleIPChecks(vueObj);
      if (vueObj.jobDetail.showAllPanelist) {
        vueObj.requiredPanel = "allpanelist";
      } else if (
        !vueObj.jobDetail.showAllPanelist &&
        vueObj.jobDetail.assignedPanelist.length > 0
      ) {
        vueObj.requiredPanel = "partpanelist";
      } else {
        vueObj.requiredPanel = "nopanelist";
      }
      vueObj.$forceUpdate();
    }
  } catch (error) {
    console.error(error);
  } finally {
    vueObj.LoaderStatus = false;
    vueObj.jobDetailCheck = JSON.parse(JSON.stringify(vueObj.jobDetail));
    vueObj.passingPercentageCheck = JSON.parse(
      JSON.stringify(vueObj.passingPercentageData)
    );
  }
};
const handleIPChecks = (vueObj) => {
  for (let i in vueObj.jobDetail.interviewProcess.process) {
    let process = vueObj.jobDetail.interviewProcess.process[i];
    handleInvalidRounChecks(vueObj, i, process);
    if (vueObj.checkValidRound(process.id)) {
      if (vueObj.selectedIPIndex === null) {
        vueObj.selectedIPIndex = process.id;
        if (process.type === "assesment") {
          vueObj.selectedEvaluators = process.selevaluator;
          vueObj.checkAutoTest();
        }
      }
      if (
        vueObj.selectedIPIndex != process.id &&
        process.type === "assesment"
      ) {
        process.selectedtests.forEach((test) =>
          vueObj.selectedTestIds.add(test.testID)
        );
      }
    }
  }
};
const handleInvalidRounChecks = (vueObj, i, process) => {
  if (!vueObj.checkValidRound(process.id)) {
    vueObj.ipValidations[i] = {};
    vueObj.passingPercentageData[i] = null;
  } else if (process.type === "assesment") {
    vueObj.fillAssessment(i, process.passingPercentage);
    if (vueObj.isDateInvalid("closeTestdt", i)) {
      vueObj.ipValidations[i].saveAndApprove = true;
    }
  } else {
    vueObj.fillF2f(i);
    if (vueObj.isDateInvalid("endDate", i)) {
      vueObj.ipValidations[i].saveAndApprove = true;
    }
  }
};
const searchLoc = async (vueObj) => {
  try {
    if (!vueObj.firstload) {
      vueObj.searchloc = vueObj.searchloc.trim();
    }

    const res = await getsearchresloc(vueObj.searchloc);
    if (res.status == 200) {
      vueObj.searchlocres = res.data.data;
    }
  } catch (error) {
    console.error(error);
  }
  vueObj.firstload = false;
};
const searchSkl = async (vueObj) => {
  try {
    if (!vueObj.firstload) {
      vueObj.searchskl = vueObj.searchskl.trim();
    }

    const res = await getsearchresskl(vueObj.searchskl);
    if (res.status == 200) {
      vueObj.searchsklres = res.data.data;
    }
  } catch (error) {
    console.error(error);
  }
  vueObj.firstload = false;
};
const addconfig = async (vueObj) => {
  try {
    if (!vueObj.testConfigData.config.dispCount) {
      vueObj.testConfigData.config.dispCount = true;
    }
    if (!vueObj.testConfigData.config.dispDuration) {
      vueObj.testConfigData.config.dispDuration = true;
    }
    if (!vueObj.testConfigData.config.includeEndTest) {
      vueObj.testConfigData.config.includeEndTest = true;
    }

    if (vueObj.testinstruction == "not_accepted") {
      vueObj.globalWorks = true;
    }

    if (vueObj.globalWorks && !vueObj.fieldsinvalid) {
      vueObj.errorstatus = false;
      getDesiredContent(vueObj, "testDesc");
      getDesiredContent(vueObj, "testInst");
      vueObj.testConfigData.config.maxnoattempts =
        vueObj.testConfigData.config.maxnoattempts.toString();
      let payload = {
        portion: "Config",
        testID: vueObj.testConfigData.testID,
        name: vueObj.testConfigData.configName,
        config: vueObj.testConfigData.config,
      };
      payload.config.timebetweenattempts = payload.config.timebnvalue;
      // CREATE A NEW CONFIG
      const res = await addConfig(payload);
      if (res.status == 200) {
        vueObj.successModal("Configuration added successfully");
        vueObj.searchConfig = "";
        vueObj.openConfigModal();
        vueObj.$bvModal.hide("confirm-edit");
        vueObj.addques1 = true;
        vueObj.addques2 = true;

        if (
          vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
            .configID !== null &&
          vueObj.testConfigData.configID ===
            vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
              .configID
        ) {
          vueObj.passingPercentageData[vueObj.selectedIPIndex] =
            vueObj.testConfigData.config.passingPercentage;
          vueObj.jobDetail.interviewProcess.process[
            vueObj.selectedIPIndex
          ].openTestdt = vueObj.testConfigData.config.openTestdt;
          vueObj.jobDetail.interviewProcess.process[
            vueObj.selectedIPIndex
          ].closeTestdt = vueObj.testConfigData.config.closeTestdt;
          vueObj.jobDetail.interviewProcess.process[
            vueObj.selectedIPIndex
          ].duration = vueObj.testConfigData.config.testDuration;
        }
      } else if (res.status === 409) {
        vueObj.errorModal("Config name already exists");
      }
    } else {
      vueObj.errorstatus = true;
      //Additional Check
    }
  } catch (error) {
    console.error(error);
  }
};
const saveExistConfig = async (vueObj) => {
  try {
    if (!vueObj.testConfigData.config.dispCount) {
      vueObj.testConfigData.config.dispCount = true;
    }
    if (!vueObj.testConfigData.config.dispDuration) {
      vueObj.testConfigData.config.dispDuration = true;
    }
    if (!vueObj.testConfigData.config.includeEndTest) {
      vueObj.testConfigData.config.includeEndTest = true;
    }

    if (vueObj.testinstruction == "not_accepted") {
      vueObj.globalWorks = true;
    }

    if (vueObj.globalWorks && !vueObj.fieldsinvalid) {
      getDesiredContent(vueObj, "testDesc");
      let payload = {
        configID: vueObj.testConfigData.configID,
        config: vueObj.testConfigData.config,
        name: vueObj.testConfigData.configName,
        check: vueObj.check,
      };
      const res = await editConfig(payload);
      if (res.status == 200) {
        vueObj.searchConfig = "";
        vueObj.successModal("Configuration updated successfully");
        vueObj.$bvModal.hide("expired-config");
        vueObj.$bvModal.hide("confirm-edit");
        vueObj.$bvModal.hide("modal-1");
        vueObj.addques1 = true;
        vueObj.addques2 = true;

        if (
          vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
            .configID !== null &&
          vueObj.testConfigData.configID ===
            vueObj.jobDetail.interviewProcess.process[vueObj.selectedIPIndex]
              .configID
        ) {
          vueObj.passingPercentageData[vueObj.selectedIPIndex] =
            vueObj.testConfigData.config.passingPercentage;
          vueObj.jobDetail.interviewProcess.process[
            vueObj.selectedIPIndex
          ].openTestdt = vueObj.testConfigData.config.openTestdt;
          vueObj.jobDetail.interviewProcess.process[
            vueObj.selectedIPIndex
          ].closeTestdt = vueObj.testConfigData.config.closeTestdt;
          vueObj.jobDetail.interviewProcess.process[
            vueObj.selectedIPIndex
          ].duration = vueObj.testConfigData.config.testDuration;
        }
      } else if (res.status == 409) {
        vueObj.$bvModal.show("confirm-edit");
      }

      vueObj.errorstatus = false;
    } else {
      vueObj.errorstatus = true;
      //Additional Check
    }
  } catch (error) {
    console.error(error);
  }
};
const getdosanddonts = async (vueObj) => {
  const res = await dosanddontslist();
  if (res.status == 200) {
    const data = res.data.data;
    for (let i in data) {
      if (data[i].type == "Dos and Donts") {
        vueObj.defaultdosanddonts = data[i].codeList;
        break;
      }
    }
  }
};
const checkAutoTest = async (vueObj) => {
  try {
    let payload = {
      testID: vueObj.jobDetail.interviewProcess.process[
        vueObj.selectedIPIndex
      ].selectedtests.map((test) => test.testID),
    };
    const response = await checkTestAutocorrected(payload);
    vueObj.ipValidations[vueObj.selectedIPIndex].autoCorrectCheck =
      response.data.data.Detail.testAutocorrect;
    if (vueObj.ipValidations[vueObj.selectedIPIndex].autoCorrectCheck) {
      vueObj.ipValidations[vueObj.selectedIPIndex].selectedEvals = false;
    }
    vueObj.$forceUpdate();
  } catch (error) {
    console.error(error);
  }
};

const getDesiredContent = (vueObj, contentType) => {
  const tempDiv = document.createElement("div");
  const contentMapping = {
    testDesc: vueObj.testConfigData.config.testDesc,
    testInst: vueObj.testConfigData.config.testInst,
  };
  tempDiv.innerHTML = contentMapping[contentType] || "";
  const pTags = tempDiv.querySelectorAll("p");

  let endIndex = pTags.length;

  for (let i = pTags.length - 1; i >= 0; i--) {
    if (isBetweenContentTag(pTags[i])) {
      endIndex = i + 1;
      break;
    }
  }

  pTags.forEach((pTag, index) => {
    if (index >= endIndex && !pTag.textContent.trim()) {
      tempDiv.removeChild(pTag);
    }
  });

  if (contentType === "testDesc") {
    vueObj.testConfigData.config.testDesc = tempDiv.innerHTML;
  } else if (contentType === "testInst") {
    vueObj.testConfigData.config.testInst = tempDiv.innerHTML;
  }
};

const isBetweenContentTag = (element) => {
  return element.textContent.trim() !== "";
};

module.exports = {
  openConfigModal,
  getVendors,
  getEvaluators,
  getIntProcess,
  getJobDetails,
  searchLoc,
  searchSkl,
  addconfig,
  saveExistConfig,
  getdosanddonts,
  checkAutoTest,
};
